import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "@/components/ToastNotification";
import { api } from "@/lib/api";
import { useEffect, useState } from "react";
import { ConvenioEditProps } from "./interface/Convenios.interface";

const ConveniosEdit = ({ open, onOpenChange, convenio, onSuccess }: ConvenioEditProps) => {

  const [formData, setFormData] = useState({
    descricao: "",
    ans: "",
    ativo: true,
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (convenio) {
      setFormData({
        descricao: convenio.descricao || "",
        ans: convenio.ans || "",
        ativo: convenio.ativo ?? true,
      });
    } else {
      setFormData({
        descricao: "",
        ans: "",
        ativo: true,
      });
    }
  }, [convenio, open]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload: any = {
        descricao: formData.descricao,
        ativo: formData.ativo,
      };

      if (formData.ans) {
        payload.ans = formData.ans;
      }

      if (convenio) {
        await api.put(`/api/convenios/${convenio.id}`, payload);
        toast.success("Convênio atualizado com sucesso!");
      } else {
        await api.post("/api/convenios", payload);
        toast.success("Convênio criado com sucesso!");
      }

      onSuccess();
      onOpenChange(false);
    } catch (error: any) {
      console.error("Erro ao salvar convênio:", error);
      toast.error(error?.response?.data?.message || "Erro ao salvar o convênio");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => onOpenChange(false);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {convenio ? "Editar Convênio" : "Novo Convênio"}
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Descrição */}
            <div className="space-y-2 md:col-span-2">
              <Label htmlFor="descricao">Descrição *</Label>
              <Input
                id="descricao"
                value={formData.descricao}
                onChange={(e) => setFormData({ ...formData, descricao: e.target.value })}
                placeholder="Ex: Unimed, Bradesco Saúde"
                maxLength={100}
                required
              />
              <p className="text-xs text-muted-foreground">
                Nome do convênio (máximo 100 caracteres)
              </p>
            </div>

            {/* ANS */}
            <div className="space-y-2">
              <Label htmlFor="ans">ANS</Label>
              <Input
                id="ans"
                value={formData.ans}
                onChange={(e) => setFormData({ ...formData, ans: e.target.value })}
                placeholder="Ex: 123456"
                maxLength={20}
              />
              <p className="text-xs text-muted-foreground">
                Número da ANS (máximo 20 caracteres)
              </p>
            </div>

            {/* Ativo */}
            <div className="space-y-2 md:col-span-2">
              <div className="flex items-center space-x-2">
                <Switch
                  id="ativo"
                  checked={formData.ativo}
                  onCheckedChange={(checked) =>
                    setFormData({ ...formData, ativo: checked })
                  }
                />
                <Label htmlFor="ativo">Convênio Ativo</Label>
              </div>
              <p className="text-xs text-muted-foreground">
                Se desativado, o convênio não estará disponível para seleção
              </p>
            </div>
          </div>

          <div className="flex justify-end gap-2 pt-4">
            <Button type="button" variant="outline" onClick={handleClose} disabled={loading}>
              Cancelar
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? "Salvando..." : convenio ? "Atualizar" : "Criar"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ConveniosEdit;

